import { RootState } from '../../../types';

const modelDeploymentSelector = (state: RootState) => state.ui.modelDeployment;

export { modelDeploymentSelector };
